import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AutoChatReplyCopyConfirmationModalPlannerFragmentDoc } from './AnswerMessageAutoChatReplyCopyConfirmationModal.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchPlannersInSameCorporationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchPlannersInSameCorporationQuery = { __typename?: 'Query', plannersInSameCorporation: Array<{ __typename?: 'Planner', id: string, name: string, autoChatReplySettings: Array<{ __typename?: 'AutoChatReplySetting', id: string }> }> };

export type FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables = Types.Exact<{
  srcPlannerId: Types.Scalars['ID']['input'];
  dstPlannerIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  strategy: Types.AutoChatReplySettingCopyStrategy;
}>;


export type FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery = { __typename?: 'Query', conflictsOfAutoChatReplySettingsBetweenSrcAndDst: Array<{ __typename?: 'AutoChatReplySettingCopyConflict', plannerId: string }> };

export type CopyAutoChatReplySettingsMutationVariables = Types.Exact<{
  srcPlannerId: Types.Scalars['ID']['input'];
  dstPlannerIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  strategy: Types.AutoChatReplySettingCopyStrategy;
  settingIdsAllowedToOverwrite: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type CopyAutoChatReplySettingsMutation = { __typename?: 'Mutation', copyAutoChatReplySettings: any };


export const FetchPlannersInSameCorporationDocument = gql`
    query FetchPlannersInSameCorporation {
  plannersInSameCorporation {
    id
    autoChatReplySettings {
      id
    }
    ...AutoChatReplyCopyConfirmationModalPlanner
  }
}
    ${AutoChatReplyCopyConfirmationModalPlannerFragmentDoc}`;

/**
 * __useFetchPlannersInSameCorporationQuery__
 *
 * To run a query within a Vue component, call `useFetchPlannersInSameCorporationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlannersInSameCorporationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchPlannersInSameCorporationQuery();
 */
export function useFetchPlannersInSameCorporationQuery(options: VueApolloComposable.UseQueryOptions<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables>(FetchPlannersInSameCorporationDocument, {}, options);
}
export function useFetchPlannersInSameCorporationLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables>(FetchPlannersInSameCorporationDocument, {}, options);
}
export type FetchPlannersInSameCorporationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchPlannersInSameCorporationQuery, FetchPlannersInSameCorporationQueryVariables>;
export const FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstDocument = gql`
    query FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDst($srcPlannerId: ID!, $dstPlannerIds: [ID!]!, $strategy: AutoChatReplySettingCopyStrategy!) {
  conflictsOfAutoChatReplySettingsBetweenSrcAndDst(
    srcPlannerId: $srcPlannerId
    dstPlannerIds: $dstPlannerIds
    strategy: $strategy
  ) {
    plannerId
  }
}
    `;

/**
 * __useFetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery__
 *
 * To run a query within a Vue component, call `useFetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery({
 *   srcPlannerId: // value for 'srcPlannerId'
 *   dstPlannerIds: // value for 'dstPlannerIds'
 *   strategy: // value for 'strategy'
 * });
 */
export function useFetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery(variables: FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables | VueCompositionApi.Ref<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables> | ReactiveFunction<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>(FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstDocument, variables, options);
}
export function useFetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstLazyQuery(variables?: FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables | VueCompositionApi.Ref<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables> | ReactiveFunction<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>(FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstDocument, variables, options);
}
export type FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQuery, FetchConflictsOfAutoChatReplySettingsBetweenSrcAndDstQueryVariables>;
export const CopyAutoChatReplySettingsDocument = gql`
    mutation CopyAutoChatReplySettings($srcPlannerId: ID!, $dstPlannerIds: [ID!]!, $strategy: AutoChatReplySettingCopyStrategy!, $settingIdsAllowedToOverwrite: [ID!]!) {
  copyAutoChatReplySettings(
    srcPlannerId: $srcPlannerId
    dstPlannerIds: $dstPlannerIds
    strategy: $strategy
    settingIdsAllowedToOverwrite: $settingIdsAllowedToOverwrite
  )
}
    `;

/**
 * __useCopyAutoChatReplySettingsMutation__
 *
 * To run a mutation, you first call `useCopyAutoChatReplySettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopyAutoChatReplySettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopyAutoChatReplySettingsMutation({
 *   variables: {
 *     srcPlannerId: // value for 'srcPlannerId'
 *     dstPlannerIds: // value for 'dstPlannerIds'
 *     strategy: // value for 'strategy'
 *     settingIdsAllowedToOverwrite: // value for 'settingIdsAllowedToOverwrite'
 *   },
 * });
 */
export function useCopyAutoChatReplySettingsMutation(options: VueApolloComposable.UseMutationOptions<CopyAutoChatReplySettingsMutation, CopyAutoChatReplySettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CopyAutoChatReplySettingsMutation, CopyAutoChatReplySettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CopyAutoChatReplySettingsMutation, CopyAutoChatReplySettingsMutationVariables>(CopyAutoChatReplySettingsDocument, options);
}
export type CopyAutoChatReplySettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CopyAutoChatReplySettingsMutation, CopyAutoChatReplySettingsMutationVariables>;